import ext from '@/../src/api/apiExt.js'
export default Object.assign({}, ext)